import { Id } from "shared/src/models/framework/db";
import { PollCard } from "shared/src/network/requests/poll/poll-req-models";

export const getAppMessage = (poll: Id<PollCard>) => {
    let text = poll.questionText.join("\n") + "\n What is your opinion on this? \n";
    const url = `https://www.flashmob.live?id=${poll.id}`;
    const shareUrl = {
        whatsApp: "whatsapp://send?text=" + text + url,
        facebookNewsFeed:
            "https://www.facebook.com/sharer/sharer.php?u=" +
            url +
            "&quote=" +
            text +
            "&hashtag=" +
            text,
        facebookMessenger:
            "https://www.facebook.com/dialog/send?link=" + url + "&redirect_uri=" + url,
        twitter: "https://twitter.com/share?url=" + url + "&text=" + text + "&hashtag=" + text,
    };
    return shareUrl;
};

export const getLink = (poll: Id<PollCard>) => {
    let text = `https://www.flashmob.live?id=${poll.id}`;
    return text;
};

export const navigatorShare = (poll: Id<PollCard>, files?: Blob[], linkParam?: string) => {
    let url = `https://www.flashmob.live?id=${poll.id}`;
    if (linkParam) url += `&p=${linkParam}`;
    const shareData: ShareData & { files?: Array<Blob> } = {
        url,
        text: `${poll.questionText.join(
            "\n"
        )}\n${url}\n\nFlashMob! : Hear the World!\nWorld's only flash Q&A social network.`,
        title: "Flashmob.Live",
        // files: files,
    };
    navigator.share?.(shareData);
};

export const copyLink = (poll: Id<PollCard>, linkParam?: string) => {
    let url = `https://www.flashmob.live?id=${poll.id}`;
    if (linkParam) url += `&p=${linkParam}`;
    navigator.clipboard.writeText(url);
};
